module.exports = __webpack_public_path__ + "img/bh.2366200b.svg";